import { AUTH_LOGIN_URL, AUTH_SIGNUP_URL } from '@/config/auth'
import React, { ComponentProps } from 'react'
import { Link } from 'react-router-dom'
import { cn } from '../lib/utils'

type LoggedOutUserProps = ComponentProps<'div'>

export const LoggedOutUser: React.FC<LoggedOutUserProps> = ({ className }) => {
  return (
    <div
      className={cn(
        'flex items-center justify-end gap-2 self-stretch text-center leading-6',
        className
      )}
    >
      <Link
        to={
          AUTH_LOGIN_URL +
          '?product=ai-business' +
          '&redirectTo=' +
          encodeURIComponent(window.location.origin)
        }
        className="my-auto hidden items-center justify-center gap-2.5 self-stretch rounded-lg border border-solid border-white/70 bg-white px-3 py-2 text-primary transition-colors hover:bg-gray-50 md:flex"
      >
        <span className="my-auto self-stretch text-primary">Sign in</span>
      </Link>
      <Link
        id="logged-out-user-button--redirect-to-signup"
        to={
          AUTH_SIGNUP_URL +
          '?product=ai-business' +
          '&redirectTo=' +
          encodeURIComponent(window.location.origin)
        }
        className="my-auto flex items-center justify-center gap-1 self-stretch rounded-lg bg-primary px-3 py-2 text-white transition-colors hover:bg-gray-800"
      >
        <span className="my-auto self-stretch text-white">Sign up</span>
        <img
          src="https://cdn.builder.io/api/v1/image/assets/fe2c5ce2c4a6499bb0a9fb0e8c30a2c9/061bcaffa54e8997515a6a81e1949a4dd096f190?placeholderIfAbsent=true"
          alt="Arrow icon"
          className="my-auto aspect-[1] w-4 shrink-0 self-stretch object-contain"
        />
      </Link>
    </div>
  )
}
